import { connect } from 'react-redux'
import UserEdit from '../../components/Users/UserEdit.js'
import {updateUser} from "../../actions/index";


const mapStateToProps = state => {
    return {
        isAdmin: state.auth.adminInfo === 1
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        updateUser: (data) => {
            return dispatch(updateUser(data));
        }
    }
};


export default connect(
    mapStateToProps,
    mapDispatchToProps

)(UserEdit);
